export type SettingsNavItemConfig = {
  title: string
  href: string
  requiresWriteAccess: boolean
}

export function filterSettingsNavItemsForAccess<T extends SettingsNavItemConfig>(
  items: readonly T[],
  canWriteOrgData: boolean
): Array<Omit<T, 'requiresWriteAccess'>> {
  return items
    .filter((item) => canWriteOrgData || !item.requiresWriteAccess)
    .map(({ requiresWriteAccess: _requiresWriteAccess, ...item }) => item)
}
